// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.node-table-container {
  width: 100%;
  overflow-x: hidden;
  padding: 20px;
  margin-left: 0%;
  margin-top: -2%;
}

.node-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.node-table tbody{
    display: block;
    max-height: 55vh;
    min-width:100%;
    overflow-y: auto;
    overflow-x: hidden;
}

/* Base styles for all table cells */
.node-table th, 
.node-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Header styling */
.node-table-thead th {
  background-color: #0c3135;
  color: white;
  vertical-align: middle;
}

/* Row styling */
.node-table-tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.node-table-tbody tr:hover {
  background-color: #ddd;
}

/* Sort button styles */
.header-sort-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.header-label {
  flex-grow: 1;
  text-align: center;
}

.sort-button-container {
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 5px;
}

.sort-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 12px;
  color: #ddd;
  line-height: 1;
}

.sort-button.active {
  color: white;
  font-weight: bold;
}

.sort-button:hover {
  color: #adabab;
}

.node-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

/* Base styles for all cells */
.node-table th, 
.node-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  box-sizing: border-box;
  word-break: break-word;
}

/* Header styling */
.node-table-thead th {
  background-color: #0c3135;
  color: white;
  vertical-align: middle;
  position: relative;
}

/* Important: Force same-width columns in both header and body */
.node-table colgroup col {
  width: auto;
}

/* Define column widths */
.cluster-name-col { width: 20.66%; }
.node-name-col { width: 35.66%; }
.cpu-usage-col, .cpu-limit-col, .cpu-percent-col,
.memory-usage-col, .memory-limit-col, .memory-percent-col {
  width: 11.11%;
}

/* Row styling */
.node-table-tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.node-table-tbody tr:hover {
  background-color: #ddd;
}

/* Sort buttons styling */
.header-sort-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

@media  (max-width: 321px) {
  .node-table{
    width:98%;
    height:35vh;
  }
  .node-table thead{
    width:98%;
    height:10vh;
  }
}

@media (min-width: 426px) and (max-width: 769px) {
  .node-table tbody{
    max-height: 40vh;
  }
}

@media (min-width: 1025px) and (max-width: 1441px) {
  .node-table{
    max-height: 67vh;
  }
  .node-table tbody {
    display: block;
    max-height: 70vh !important;
  }
}


@media (min-width: 1441px) and (max-width: 1921px) {
  .node-table {
    max-height: 57vh;
    display: table;
    width: 100% !important;
  }
  
  .node-table tbody {
    display: block;
    max-height: 50vh  !important; 
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
  }
  
  .node-table thead {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  
  .node-table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
}

@media (min-width: 1921px){
  .node-table{
    max-height: 80vh;
  }
  .node-table tbody {
    display: block;
    max-height: 80vh !important;
    overflow-y: auto; /* Enable vertical scroll */
    overflow-x: hidden;
  }
  .node-table {
    font-size: 20px;
  }

  .node-table tbody{
    display: block;
    max-height: 55vh;
    min-width:100%;
    width:100vh;
    overflow-y: auto;
    overflow-x: hidden;
}
}

.node-table thead,
.node-table tbody {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.node-table tbody {
  display: block;
  max-height: 55vh;
  overflow-y: auto;
}

.node-table tbody tr {
  display: table;
  width: 100%;
}

/* Ensure all cells maintain their proper width */
.node-table th, 
.node-table td {
  width: auto;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/components/NodeDashboard/NodeTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,oCAAoC;AACpC;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,WAAW;AACb;;AAEA,yBAAyB;AACzB,oBAAoB,aAAa,EAAE;AACnC,iBAAiB,aAAa,EAAE;AAChC;;EAEE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,SAAS;IACT,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,2BAA2B;EAC7B;AACF;;;AAGA;EACE;IACE,gBAAgB;IAChB,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,2BAA2B;IAC3B,gBAAgB,EAAE,2BAA2B;IAC7C,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;AACA;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA,iDAAiD;AACjD;;EAEE,WAAW;EACX,sBAAsB;AACxB","sourcesContent":[".node-table-container {\n  width: 100%;\n  overflow-x: hidden;\n  padding: 20px;\n  margin-left: 0%;\n  margin-top: -2%;\n}\n\n.node-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.node-table tbody{\n    display: block;\n    max-height: 55vh;\n    min-width:100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n/* Base styles for all table cells */\n.node-table th, \n.node-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Header styling */\n.node-table-thead th {\n  background-color: #0c3135;\n  color: white;\n  vertical-align: middle;\n}\n\n/* Row styling */\n.node-table-tbody tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.node-table-tbody tr:hover {\n  background-color: #ddd;\n}\n\n/* Sort button styles */\n.header-sort-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.header-label {\n  flex-grow: 1;\n  text-align: center;\n}\n\n.sort-button-container {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  right: 5px;\n}\n\n.sort-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  font-size: 12px;\n  color: #ddd;\n  line-height: 1;\n}\n\n.sort-button.active {\n  color: white;\n  font-weight: bold;\n}\n\n.sort-button:hover {\n  color: #adabab;\n}\n\n.node-table {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n\n/* Base styles for all cells */\n.node-table th, \n.node-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n  box-sizing: border-box;\n  word-break: break-word;\n}\n\n/* Header styling */\n.node-table-thead th {\n  background-color: #0c3135;\n  color: white;\n  vertical-align: middle;\n  position: relative;\n}\n\n/* Important: Force same-width columns in both header and body */\n.node-table colgroup col {\n  width: auto;\n}\n\n/* Define column widths */\n.cluster-name-col { width: 20.66%; }\n.node-name-col { width: 35.66%; }\n.cpu-usage-col, .cpu-limit-col, .cpu-percent-col,\n.memory-usage-col, .memory-limit-col, .memory-percent-col {\n  width: 11.11%;\n}\n\n/* Row styling */\n.node-table-tbody tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.node-table-tbody tr:hover {\n  background-color: #ddd;\n}\n\n/* Sort buttons styling */\n.header-sort-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n@media  (max-width: 321px) {\n  .node-table{\n    width:98%;\n    height:35vh;\n  }\n  .node-table thead{\n    width:98%;\n    height:10vh;\n  }\n}\n\n@media (min-width: 426px) and (max-width: 769px) {\n  .node-table tbody{\n    max-height: 40vh;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1441px) {\n  .node-table{\n    max-height: 67vh;\n  }\n  .node-table tbody {\n    display: block;\n    max-height: 70vh !important;\n  }\n}\n\n\n@media (min-width: 1441px) and (max-width: 1921px) {\n  .node-table {\n    max-height: 57vh;\n    display: table;\n    width: 100% !important;\n  }\n  \n  .node-table tbody {\n    display: block;\n    max-height: 50vh  !important; \n    overflow-y: auto;\n    overflow-x: hidden;\n    width: 100%;\n  }\n  \n  .node-table thead {\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  }\n  \n  .node-table tbody tr {\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  }\n}\n\n@media (min-width: 1921px){\n  .node-table{\n    max-height: 80vh;\n  }\n  .node-table tbody {\n    display: block;\n    max-height: 80vh !important;\n    overflow-y: auto; /* Enable vertical scroll */\n    overflow-x: hidden;\n  }\n  .node-table {\n    font-size: 20px;\n  }\n\n  .node-table tbody{\n    display: block;\n    max-height: 55vh;\n    min-width:100%;\n    width:100vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n}\n\n.node-table thead,\n.node-table tbody {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.node-table tbody {\n  display: block;\n  max-height: 55vh;\n  overflow-y: auto;\n}\n\n.node-table tbody tr {\n  display: table;\n  width: 100%;\n}\n\n/* Ensure all cells maintain their proper width */\n.node-table th, \n.node-table td {\n  width: auto;\n  box-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
